<style lang="less" scoped>
  @border-color: #dddee1;
  @bg-color: #f5f5f5;
  @bg-hover-color: #e5e5e5;
  .invoice {
    display: inline-block;
    vertical-align: top;
    border: 1px solid @border-color;
    margin-right: 5px;
    margin-bottom: 5px;
    .check-box {
      margin: 0;
      padding: 2px 0 2px 5px;
      background: @bg-color;
    }
    .invoice-item {
      display: inline-block;
    }
    .invoice-name {
      display: inline-block;
      padding: 4px 8px;
      background: @bg-color;
      cursor: grab;
    }
    .download {
      display: inline-block;
      padding: 4px 8px;
      background: @bg-color;
      border-left: 1px solid @border-color;
      cursor: pointer;
      &:hover {
        background: @bg-hover-color;
      }
    }
  }
</style>
<template>
  <div
    v-if="invoice.ocr_invoice_list&&invoice.ocr_invoice_list.length"
    class="invoice"
    style="display: inline-block"
  >
    <Checkbox
      v-show="showCheckBox"
      v-model="invoice._checkout"
      class="check-box"
    />
    <div
      v-for="(ocr_result, index) in invoice.ocr_invoice_list"
      :key="index"
      class="invoice-item"
      :data-rough-invoice="invoice"
      draggable="true"
      :mask="false"
      @dragstart="dragstart"
    >
      <div class="invoice-name">
        <span style="margin-right: 8px">发票号码/代码: {{ ocr_result.number }} / {{ ocr_result.code }}</span>
        <span>金额: {{ $util.formatPrice(ocr_result.total) }}</span>
      </div>
      <div
        class="download"
        @click="$emit('preview', invoice)"
      >
        <Icon type="md-download" />
      </div>
      <div
        v-show="showLink"
        class="download"
        @click="$emit('link', invoice)"
      >
        <Button
          size="small"
          type="primary"
          ghost
        >
          关联
        </Button>
      </div>
    </div>
  </div>
  <!-- 发票未正确识别，显示如下 -->
  <div
    v-else
    class="invoice"
  >
    <Checkbox
      v-model="invoice._checkout"
      class="check-box"
    />
    <div class="invoice-name">
      {{ invoice.ori_name }}
      <small>发票未正确识别</small>
    </div>
    <div
      class="download"
      @click="$emit('preview', invoice)"
    >
      <Icon type="md-download" />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      invoice: {
        type: Object,
        required: true
      },
      showCheckBox: {
        type: Boolean,
        default:() => true
      },
      showLink: {
        type: Boolean,
        default:() => false
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      // ocr_invoice_list() {
      //   if (this.invoice.ocr_status === 'success') {
      //     const ocr_res = JSON.parse(this.invoice.ocr_result);
      //     return ocr_res['response']['data']['identify_results'].map(_ => _.details);
      //   } else {
      //     return [];
      //   }
      // }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      /*  preview(invoice = {}) {
        const filepath = invoice.oss_img_path ? invoice.oss_img_path : invoice.oss_pdf_path;
        if (!filepath) {
          this.$Message.error('未找到文件路径，无法预览');
          return;
        }
        const oss_url = this.$util.publicOSSUrl(filepath);
        window.open(oss_url);
      },  */
      dragstart(ev) {
        ev.dataTransfer.setData('rough-invoice', JSON.stringify(this.invoice));
      },
    }
  }
</script>
